import { message } from 'antd';
import { call, put, takeEvery, all, fork, takeLatest } from 'redux-saga/effects'
import {
    FETCH_MIPS, FETCH_MIPS_FILTER, FETCH_MIPS_START, FETCH_MIPS_SUCCESS, FETCH_MIPS_ERROR, SET_MIPS_PAGINATION,
    ADD_MIP, ADD_MIP_SUCCESS, ADD_MIP_ERROR, UPDATE_MIP, UPDATE_MIP_SUCCESS, UPDATE_MIP_ERROR, FETCH_ALL_MIP_MACHINES, FETCH_ALL_MIP_MACHINES_SUCCESS, FETCH_ALL_MIP_MACHINES_ERROR, ADD_UPDATE_MIP_MACHINE, ADD_UPDATE_MIP_MACHINE_SUCCESS, ADD_UPDATE_MIP_MACHINE_ERROR, DELETE_MIP_MACHINE, DELETE_MIP_MACHINE_SUCCESS, DELETE_MIP_MACHINE_ERROR
} from "../../actions/admin/mipsAction";
import { HIDE_MODAL, SUBMIT_START, SUBMIT_ERROR } from "../../actions/admin/modalActions";
import { getMipsAPI, addUpdateMipAPI, fetchAllMipMachinesAPI, addUpdateMipMachineAPI, deleteMipMachineAPI, getMipsFilterAPI } from "../../../services/mips-service";
import { history } from '../../store';
import { navigateTo } from '../../../util/navigationService';

function* fetchMips({ payload }) {
    try {
        yield put({ type: FETCH_MIPS_START })
        const response = yield call(getMipsAPI, payload);
        if (response.success) {
            const pagination = {
                currentPage: payload.pageNo,
                pageSize: payload.pageSize,
                totalPages: response.mip.totalPages,
                totalItems: response.mip.totalItems,
            }
            yield put({ type: SET_MIPS_PAGINATION, pagination });
            yield put({ type: FETCH_MIPS_SUCCESS, mips: response.mip.mips || response.mip })
        } else {
            yield put({ type: FETCH_MIPS_ERROR, error: response.error })
            message.error('Failed to fetch sites!');
        }
    } catch (error) {
        yield put({ type: FETCH_MIPS_ERROR, error })
        message.error('Failed to fetch sites!');
    }
}

function* fetchMipsFilter({ payload }) {
    try {
        yield put({ type: FETCH_MIPS_START })
        const response = yield call(getMipsFilterAPI, payload);
        if (response.success) {
            const pagination = {
                currentPage: payload.pageNo,
                pageSize: payload.pageSize,
                totalPages: response.mip.totalPages,
                totalItems: response.mip.totalItems,
            }
            yield put({ type: SET_MIPS_PAGINATION, pagination });
            yield put({ type: FETCH_MIPS_SUCCESS, mips: response.mip.mips || response.mip })
        } else {
            yield put({ type: FETCH_MIPS_ERROR, error: response.error })
            message.error('Failed to fetch sites!');
        }
    } catch (error) {
        yield put({ type: FETCH_MIPS_ERROR, error })
        message.error('Failed to fetch sites!');
    }
}

function* addMip({ mip }) {
    try {
        const response = yield call(addUpdateMipAPI, mip);
        if (response.success) {
            yield put({ type: ADD_MIP_SUCCESS, mip: response.mip })
            message.success('Site created successfully.');
            navigateTo({
                pathname: '/admin/master/sites',
            });
        } else {
            yield put({ type: ADD_MIP_ERROR, error: response.error })
            if (typeof response.error === "string") {
                message.error(response.error);
            } else {
                message.error('Failed to create site!');
            }
        }
    } catch (error) {
        yield put({ type: ADD_MIP_ERROR, error })
        message.error('Failed to create site!');
    }
}

function* updateMip({ mip }) {
    try {
        const response = yield call(addUpdateMipAPI, mip);
        if (response.success) {
            yield put({ type: UPDATE_MIP_SUCCESS, mip: { ...response.mip } })
            message.success('Site info updated successfully.');
        } else {
            yield put({ type: UPDATE_MIP_ERROR, error: response.error })
            if (typeof response.error === "string") {
                message.error(response.error);
            } else {
                message.error('Failed to update site info!');
            }
        }
    } catch (error) {
        yield put({ type: UPDATE_MIP_ERROR, error })
        message.error('Failed to update site info!');
    }
}

function* fetchAllMipMachines({ payload }) {
    try {

        const response = yield call(fetchAllMipMachinesAPI, payload);
        if (response.success) {
            yield put({ type: FETCH_ALL_MIP_MACHINES_SUCCESS, mipMachines: [...response.mipMachines] })
        } else {
            yield put({ type: FETCH_ALL_MIP_MACHINES_ERROR })
            if (typeof response.error === "string") {
                message.error(response.error);
            } else {
                message.error('Failed to fetch site machines!');
            }
        }
    } catch (error) {
        yield put({ type: FETCH_ALL_MIP_MACHINES_ERROR })
        message.error('Failed to fetch site machines!');
    }
}


function* addUpdateMipMachine({ payload }) {
    try {
        yield put({ type: SUBMIT_START })
        const response = yield call(addUpdateMipMachineAPI, payload);
        if (response.success) {
            if (payload.machineId === 0) {
                message.success('Added machine successfully.');
            } else {
                message.success('Updated machine successfully.');
            }

            yield put({ type: ADD_UPDATE_MIP_MACHINE_SUCCESS, mipMachine: { ...response.mipMachine } });
            yield put({ type: HIDE_MODAL })
        } else {
            yield put({ type: ADD_UPDATE_MIP_MACHINE_ERROR })
            yield put({ type: SUBMIT_ERROR })
            if (typeof response.error === "string") {
                message.error(response.error);
            } else {
                if (payload.machineId === 0) {
                    message.error('Failed to add machine!');
                } else {
                    message.error('Failed to update machine!');
                }
            }
        }
    } catch (error) {
        yield put({ type: FETCH_ALL_MIP_MACHINES_ERROR });
        yield put({ type: SUBMIT_ERROR })
        message.error('Failed to update machine!');
    }
}


function* deleteMipMachine({ payload }) {
    try {
        const response = yield call(deleteMipMachineAPI, payload);
        if (response.success) {
            message.success('Deleted machine successfully.');
            yield put({ type: DELETE_MIP_MACHINE_SUCCESS, payload });
        } else {
            yield put({ type: DELETE_MIP_MACHINE_ERROR })

            if (typeof response.error === "string") {
                message.error(response.error);
            } else {
                message.error('Failed to delete machine!');
            }
        }
    } catch (error) {
        message.error('Failed to delete machine!');
    }
}

function* mipsWatcher() {
    yield takeEvery(FETCH_MIPS, fetchMips)
    yield takeEvery(FETCH_MIPS_FILTER, fetchMipsFilter)
    yield takeEvery(ADD_MIP, addMip)
    yield takeEvery(UPDATE_MIP, updateMip)
    yield takeLatest(FETCH_ALL_MIP_MACHINES, fetchAllMipMachines)
    yield takeLatest(ADD_UPDATE_MIP_MACHINE, addUpdateMipMachine)
    yield takeLatest(DELETE_MIP_MACHINE, deleteMipMachine)

}

export default function* rootSaga() {
    yield all([
        mipsWatcher(),
    ]);
}